export const countComa = (fullString) => {
    if (typeof fullString !== "string") {
        return 0;
    }
    const matches = fullString.match(/,/g);
    return matches ? matches.length : 0;
}